import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

export type Crumb = {
  label: string;
  to?: string;
};

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm">
      <ol className="flex flex-wrap items-center gap-1.5 text-brand-cream/85">
        {items.map((c, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${c.label}-${i}`} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-brand-cream/40" />}
              {c.to && !isLast ? (
                <Link
                  to={c.to}
                  className="font-medium text-brand-cream/85 transition-smooth hover:text-brand-gold"
                >
                  {c.label}
                </Link>
              ) : (
                <span className={isLast ? "font-semibold text-brand-gold" : "text-brand-cream/85"}>
                  {c.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
